import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, HttpClient } from "@angular/common/http";
import { DatePipe, HashLocationStrategy, LocationStrategy } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from "@angular/core";

// Routing
import { AppRoutingModule } from "./app-routing.module";

// App components
import { AppComponent } from "./app.component";
import { HeaderComponent } from "./components/layouts/header/header.component";
import { FooterComponent } from "./components/layouts/footer/footer.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { TasksComponent } from "./components/dashboard/tasks/tasks.component";
import { TasksV1Component } from "./components/dashboard/tasks-v1/tasks-v1.component";
import { ResetPasswordComponent } from "./components/authentication/reset-password/reset-password.component";
import { PasswordExpiredComponent } from "./components/authentication/password-expired/password-expired.component";
import { VerifyComponent } from "./components/authentication/verify/verify.component";

// Shared
import { CarouselDirective } from "./shared/coursel.directive";
import { SafePipe } from "./shared/safe.pipe";

// Interceptors
import { HttpIntercepter } from "./interceptors/http.intercepter";

// PrimeNG
import { PrimeNgModule } from "./modules/prime-ng/prime-ng.module";
import { providePrimeNG } from "primeng/config";
// PrimeNG theme — Lara-based preset with blue primary & focus ring (see src/app/theme/blue-ring-preset.ts)
import { BlueRingPreset } from "./theme/blue-ring-preset";

// Third-party
import { NgxUiLoaderConfig, POSITION, SPINNER, PB_DIRECTION, NgxUiLoaderModule, NgxUiLoaderRouterModule } from "ngx-ui-loader";
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";
import { CarouselModule } from "ngx-bootstrap/carousel";
import { HighchartsChartModule } from "highcharts-angular";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: "red",
  bgsPosition: POSITION.bottomCenter,
  bgsSize: 40,
  bgsType: SPINNER.fadingCircle,
  fgsType: SPINNER.fadingCircle,
  pbDirection: PB_DIRECTION.leftToRight,
  pbThickness: 5,
  text: "Please wait...",
  textColor: "#FFFFFF",
  textPosition: "center-center",
};

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    DashboardComponent,
    TasksComponent,
    TasksV1Component,
    ResetPasswordComponent,
    PasswordExpiredComponent,
    VerifyComponent,
    CarouselDirective,
    SafePipe,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    PrimeNgModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxUiLoaderRouterModule,
    NgxDaterangepickerMd.forRoot(),
    CarouselModule,
    HighchartsChartModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    DatePipe,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: HttpIntercepter, multi: true },
    providePrimeNG({
      theme: {
        preset: BlueRingPreset,
        options: { darkModeSelector: "light" },
      },
    }),
    provideHttpClient(withInterceptorsFromDi()),
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AppModule {}
